import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ConditionalRender from '../../../components/ConditionalRender';
import {
  getRegisteredTimeSlotAndState,
  useAppContext,
} from '../../../contextProviders/AppContext';
import { TimeSlot } from '../../../types/model';
import { formatEventTimeSpan } from '../../../utils/formatDate';
import getCaption from './getCaption';
import { isPassedTimeSlot } from '../../../contextProviders/AppContext/utils';

type PropsType = {
  timeslots: Array<TimeSlot>;
  timeZone: string;
  registrationRequired: boolean;
};

const Timeslot = styled.div`
  border: 2px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: bold;
  padding: 1.25rem 1.5rem;
`;

const Timeslots = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;
  row-gap: 1rem;
  min-height: 85px;
`;

const Label = styled.p`
  font-weight: normal;
`;

const BasicItems = (props: PropsType) => {
  const { timeslots, registrationRequired } = props;
  const { t } = useTranslation();
  const { useSelector } = useAppContext();
  const [registeredToTimeSlot, registrationState] = useSelector(
    getRegisteredTimeSlotAndState
  );

  return (
    <ConditionalRender predicate={timeslots.length > 0}>
      <Timeslots>
        {timeslots.map((timeSlot: TimeSlot, i: number) => (
          <Timeslot
            key={i}
            style={{ opacity: isPassedTimeSlot(timeSlot) ? 0.25 : 1.0 }}
          >
            {formatEventTimeSpan(
              timeSlot.utcStartDate,
              timeSlot.utcEndDate,
              timeSlot.startDate,
              timeSlot.endDate,
              props.timeZone
            )}
            <ConditionalRender predicate={registrationRequired}>
              <Label>
                {getCaption(
                  timeSlot,
                  registeredToTimeSlot,
                  registrationState,
                  t
                )}
              </Label>
            </ConditionalRender>
          </Timeslot>
        ))}
      </Timeslots>
    </ConditionalRender>
  );
};

export default BasicItems;
